import {OETarget} from '../../../react-oe/oe-target';
import {OELicensingEdition} from '../../../react-oe/oe-types';
import {OEVersionTargets, OEVersionFeatureAccess, OEVersionStartSelectionDataAlphaBetaProd} from '../oe-proto-model';
import {OEBayerTargetType as OEBayerTargetType_, OEBayerStartSelectionContent} from './oe-bayer-consts';

export const OEBayerTargetType = OEBayerTargetType_;

export const OEBayerTargets = new OEVersionTargets(
    {
        [OEBayerTargetType.anatomy]: [
            OETarget.humanEye2,
            OETarget.humanEyeMicro,
            OETarget.humanEyeMacro,
            OETarget.humanEyeCornea,
            OETarget.humanEyeRetina,
            OETarget.humanEyeLid,
            OETarget.sensorySystemsEye,
            OETarget.humanEyeMuellerCell
        ],
        [OEBayerTargetType.bayer]: [
            OETarget.humanEyeAMD,
            OETarget.humanEyeDMOE,
            OETarget.humanEyeOcclusion,
            OETarget.humanEyeMembrane
        ],
        [OEBayerTargetType.surgery]: [
            OETarget.surgeryEyeCataract
        ],
        [OEBayerTargetType.opti]: [
            OETarget.zeissOpti2,
            OETarget.humanEyeAmetropia
        ],
        [OEBayerTargetType.oct]: [
            OETarget.humanEyeOCT
        ]
    },
    {
        [OEBayerTargetType.bayer]: OETarget.humanEyeOcclusion
    },
    {
        [OEBayerTargetType.bayer]: OETarget.humanEyeOcclusion
    }
);

OEBayerTargets.isOCTTarget = function(target)   {
    return OEBayerTargets.isOctTarget(target);
};

export const OEBayerFeatureAccess = new(class extends OEVersionFeatureAccess {

    constructor(versionTargets) {
        super(versionTargets);
    }

    initialFeatureAccess()  {
        let isLicensing = this.isLicensing();
        return Object.assign(this.createFeatureAccessObj(), {
            anatomyModule: !isLicensing,
            bayerModule: !isLicensing,
            surgeryModule: !isLicensing,
            optiModule: !isLicensing,
            octModule: !isLicensing
        });
    }

    featureAccessForLicensingAccess(licensingAccess)    {
        if(!licensingAccess.isLicensing)    return this.createFeatureAccessObj();

        let featureAccess = this.initialFeatureAccess();

        if(licensingAccess.isConnected) {
            featureAccess.bayerModule = true;
        }

        if(licensingAccess.isValid)    {
            let editions = [OELicensingEdition.viewer];
            if(editions.includes(licensingAccess.edition))    {
                featureAccess.bayerModule = true;
                featureAccess.anatomyModule = true;
            }

            editions = [
                OELicensingEdition.basic,
                OELicensingEdition.singleUser,
                OELicensingEdition.extended,
                OELicensingEdition.professional,
                OELicensingEdition.branchOffice,
                OELicensingEdition.master
            ];

            if(editions.includes(licensingAccess.edition))  {
                featureAccess.anatomyModule = true;
                featureAccess.bayerModule = true;
                featureAccess.surgeryModule = true;
                featureAccess.optiModule = true;
                featureAccess.octModule = true;
            }
        }

        return featureAccess;
    }
})(OEBayerTargets);

export const OEBayerStartSelectionData = new OEVersionStartSelectionDataAlphaBetaProd(
    OEBayerTargets,
    OEBayerStartSelectionContent
);